import React from 'react';

import { minDimension } from './utils';
import { ISankeyLink } from './interfaces';
import sankeyLinkHorizontal from './D3Sankey/sankeyLinkHorizontal';
import { isNil } from 'lodash';

interface IProps {
  link: ISankeyLink;
  color: string;
  index: number;
  onMouseOver: (
    ev: React.MouseEvent<SVGElement, MouseEvent>,
    linkIndex: number,
  ) => void;
  onMouseLeave: (
    ev: React.MouseEvent<SVGElement, MouseEvent>,
    linkIndex?: number,
  ) => void;
  onMouseMove: (
    ev: React.MouseEvent<SVGElement, MouseEvent>,
    linkIndex?: number,
  ) => void;
}

const linkFactory = sankeyLinkHorizontal();

export default ({
  link,
  color,
  index,
  onMouseOver,
  onMouseLeave,
  onMouseMove,
}: IProps) => {
  const { width, visible, isHighlight } = link;

  const pathData = linkFactory(link);
  if (!isNil(pathData)) {
    const opacity = visible ? 0.1 : 0.01;
    return (
      <path
        d={pathData}
        onMouseOver={(event) => onMouseOver(event, index)}
        onMouseOut={(event) => onMouseLeave(event, index)}
        onMouseMove={(event) => onMouseMove(event)}
        fill={'none'}
        stroke={color}
        strokeOpacity={isHighlight ? 0.3 : opacity}
        strokeWidth={minDimension(width)}
      />
    );
  } else {
    return null;
  }
};
